export default "__VITE_ASSET__BC79CWn2__"